import { buildApiUrl } from "../../services/apiConfig";
import { fetchTools } from "./api";

export const getToolById = async (id) => {
  try {
    const allTools = await fetchTools();
    
    const normalizedInputId = String(id).replace(/^0+/, '');
    
    const tool = allTools.find(tool => {
      const normalizedToolId = String(tool.id).replace(/^0+/, '');
      return normalizedToolId === normalizedInputId;
    });
    
    if (!tool) {
      throw new Error(`Tool with ID ${id} not found`);
    }
    
    return tool;
  } catch (error) {
    console.error('Error fetching tool details:', error);
    throw error;
  }
};

// Delete tool
export const deleteTool = async (id) => {
  try {
    const response = await fetch(buildApiUrl('AUTH', `/api/tools/${id}`), {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error(`API responded with status: ${response.status}`);
    }
    return true;
  } catch (error) {
    console.error('Error deleting tool:', error);
    return false;
  }
};

// Add a new tool
export const addTool = async (toolData) => {
  try {
    const response = await fetch(buildApiUrl('AUTH', '/api/tools'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(toolData),
    });
    if (!response.ok) {
      throw new Error(`API responded with status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error adding tool:', error);
    throw error;
  }
};

